import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useClient } from '../connect_api';
import { ProductService } from '../api/api_pb';

interface CreateTrackableItemModalProps {
    isOpen: boolean;
    onClose: () => void;
    productUuid: string;
    onStockCreated: () => void;
}

const CreateTrackableItemModal: React.FC<CreateTrackableItemModalProps> = ({ isOpen, onClose, productUuid, onStockCreated }) => {
    const productClient = useClient(ProductService);
    const [name, setName] = useState('');

    const handleCreate = async () => {
        if (!name.trim()) {
            toast.error('Name is required!');
            return;
        }

        try {
            await productClient.createTrackableItem({
                productUuid,
                name,
            });

            console.log('name', name);

            toast.success('Stock created successfully!');
            setName('');
            onStockCreated();
            onClose();
        } catch (error) {
            toast.error('Failed to trackable item: ' + (error as Error).message);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Create Trackable Item</h2>

                <label className="block text-sm font-medium">Name</label>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="border p-2 w-full mb-2"
                    placeholder="Enter trackable item name"
                />

                <div className="mt-4 flex justify-end">
                    <button onClick={onClose} className="bg-gray-300 px-4 py-2 rounded-md">Cancel</button>
                    <button onClick={handleCreate} className="bg-blue-600 text-white px-4 py-2 rounded-md ml-2">
                        Create
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateTrackableItemModal;
